export class UniteModel {
  code: string;
  libelle: string;
  type: string;
  uniteBase: UniteModel;
  convertionVersBase: (valeur: number) => number;
  convertionDepuisBase: (valeur: number) => number;

  static build (code: string, libelle: string, type: string): UniteModel;
  static build (code: string, libelle: string, type: string, uniteBase: UniteModel, facteurUniteBase: number): UniteModel;
  static build (code: string, libelle: string, type: string, uniteBase: UniteModel, converstionVersBase: ((valeur: number) => number), converstionDepuisBase: (valeur: number) => number): UniteModel;
  static build (code: string, libelle: string, type: string, uniteBase?: UniteModel, arg4?: number | ((valeur: number) => number), arg5?: (valeur: number) => number): UniteModel {
    return new UniteModel(code, libelle, type, uniteBase, arg4, arg5);
  }

  private constructor (code: string, libelle: string, type: string, uniteBase?: UniteModel, arg4?: number | ((valeur: number) => number), arg5?: (valeur: number) => number) {
    this.code = code;
    this.libelle = libelle;
    this.type = type;
    this.uniteBase = uniteBase;
    if (arg4 && typeof arg4 === 'number') {
      this.convertionVersBase = (valeur: number) => valeur * arg4;
      this.convertionDepuisBase = (valeur: number) => valeur / arg4;
    } else if (arg4 && typeof arg4 === 'function') {
      this.convertionVersBase = arg4;
      this.convertionDepuisBase = arg5;
    }
  }
}
